export var SESSION_ID_STORAGE_KEY = 'fedops.logger.sessionId';
export var DEFAULT_APP_VERSION = '0.0.0';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/fedops-logger/dist/es/src/conf.js
// module id = 122
// module chunks = 0 1